import { useQueryString } from '@frx/frx-react-context';
import { lowercaseKeys } from '../utils';

export const useLowercaseQueryString = (): any => ({
  queryStrings: lowercaseKeys(useQueryString().queryStrings),
});
